export function triggerBlobDownload(data: Blob, filename: string) {
    // Add encoding for deserializing punctuation marks correctly, ex: dÃ©jÃ -> déjà
    const url = URL.createObjectURL(new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), data], { type: "text/plain;charset=utf-8" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
